import { appEventGTag } from "../event";

export const event = () => {
    appEventGTag({
        page: "home",
        eventName: "click",
        eventLocationType: "link_button",
        eventLocationLabel: "Water service providers",
        eventLabel: `Click on "Water service providers" button in the infographic`
    });
};
